import axios from "axios";

export default axios.create({
    baseURL: "https://projectmgmtapi.onrender.com/api"
});